import hdaRest from "@/modules/hda/rest/hdaRest";
import authRest from "@/modules/oauth/api/authRest";
import { ActivitiesApi } from "@/api-clients/hda/openapi/activity/api";
import { AuthorizationApi } from "@/api-clients/hda/openapi/auth/api";
import { CategoriesApi } from "@/api-clients/hda/openapi/category/api";
import { CollaboratorsApi } from "@/api-clients/hda/openapi/collaborator/api";
import { LogisticProcessesApi } from "@/api-clients/hda/openapi/logisticProcess/api";
import { PlanningsApi } from "@/api-clients/hda/openapi/planning/api";
import { SitesApi } from "@/api-clients/hda/openapi/sites/api";
import { TeamsApi } from "@/api-clients/hda/openapi/team/api";

/** Shared OpenAPI client instances for HDA REST (spain-openapi / @decathlon-spain/openapi-hda). */
export const activitiesApi = new ActivitiesApi(undefined, "", hdaRest);
export const categoriesApi = new CategoriesApi(undefined, "", hdaRest);
export const collaboratorsApi = new CollaboratorsApi(undefined, "", hdaRest);
export const logisticProcessesApi = new LogisticProcessesApi(undefined, "", hdaRest);
export const planningsApi = new PlanningsApi(undefined, "", hdaRest);
export const sitesApi = new SitesApi(undefined, "", hdaRest);
export const teamsApi = new TeamsApi(undefined, "", hdaRest);

/** Token exchange / refresh — unauthenticated axios instance. */
export const hdaAuthApi = new AuthorizationApi(undefined, "", authRest);
/** Revoke session — requires Bearer token on hdaRest. */
export const hdaAuthorizedAuthApi = new AuthorizationApi(undefined, "", hdaRest);
